import { memoizeFunction } from '@agilepoint/utils-common';
import { PluginEventType, EditorPlugin, PluginEvent } from 'roosterjs-editor-types';
import { EventManager } from '../../../utils';

type ListenerCallback = (ev: PluginEvent) => void

export interface IChangeDetector {
    subscribe: (callback: ListenerCallback) => void;
    unsubscribe: (callback: ListenerCallback) => void;
}

const noop = () => { /** NOOP function */ };

const EVENT_NAME = 'CHANGE';

const events: PluginEventType[] = [PluginEventType.ContentChanged, PluginEventType.KeyUp, PluginEventType.MouseUp, PluginEventType.PendingFormatStateChanged];

export class ChangeDetectionPlugin implements EditorPlugin, IChangeDetector {
    private em: EventManager | null = new EventManager();

    getName = () => 'ChangeDetectionPlugin';

    initialize = noop;

    dispose() {
        this.em = null;
    }

    onPluginEvent(event: PluginEvent) {
        if (!events.includes(event.eventType)) {
            return;
        }
        this.em?.emit(EVENT_NAME, event);
    }

    subscribe = (callback: (ev: PluginEvent) => void) => {
        this.em?.on(EVENT_NAME, callback);
    }

    unsubscribe = (callback: (ev: PluginEvent) => void) => {
        this.em?.off(EVENT_NAME, callback);
    }
}

export const getChangeDetector = memoizeFunction((plugin: ChangeDetectionPlugin): IChangeDetector => ({ subscribe: plugin.subscribe, unsubscribe: plugin.unsubscribe }));
